module.exports = __webpack_public_path__ + "static/media/tr_imageW900_2.d051a8f0.jpg";